export const ACH_RELATIONSHIP_STATUSES = {
  PENDING: 'PENDING',
  PENDING_ID_VERIFICATION_RESULTS: 'PENDING_IDENTITY_VERIFICATION_RESULTS',
};
